import { FC } from 'react';
import { formatNumber } from 'utils/number';
import style from './price-card.module.scss';

export interface PriceCardProps {
  label: string;
  value: number | null;
  unit: string;
  valueColor?: string;
}

const PriceCard: FC<PriceCardProps> = ({ label, value, unit, valueColor }) => {
  return (
    <div className={style.card}>
      <div className={style.label}>{label}</div>
      <div
        className={style.value}
        style={valueColor ? { color: valueColor } : undefined}
      >
        {formatNumber({
          value,
          style: 'currency',
          minPrecision: 2,
          maxPrecision: 3,
        })}
      </div>
      <div className={style.unit}>{unit}</div>
    </div>
  );
};

export { PriceCard };
